import { __decorate, __metadata } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';

let UiCModalChangeAccountComponent = class UiCModalChangeAccountComponent {
    constructor(modalController) {
        this.modalController = modalController;
        this.type = 'APP';
        this.forceLogout = false;
    }
    accountSelection(event) {
        this.modalController.dismiss(event);
    }
    setDigitAccountBank(digit) {
        let account = '';
        let count = digit.length;
        let penultimate = count - 2;
        for (let i = 0; i < count; i++) {
            account += digit[i];
            if (i == penultimate) {
                account += '-';
            }
        }
        return account;
    }
    getRandomColor(i) {
        const color = ['#F7F9F9', '#BED8D4', '#78D5D7', '#63D2FF', '#2081C3'];
        return color[i % color.length];
    }
    dismiss(event) {
        if (this.forceLogout)
            event.data = 'forceLogout';
        this.modalController.dismiss(event);
    }
    verifyTypeDocument(document) {
        if (document.length === 11)
            return 'CASH_IN.DASHBOARD_MENU.DOCUMENT_CPF';
        else
            return 'CASH_IN.DASHBOARD_MENU.DOCUMENT_CNPJ';
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalChangeAccountComponent.prototype, "backgroundImage", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCModalChangeAccountComponent.prototype, "data", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalChangeAccountComponent.prototype, "accountInUse", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalChangeAccountComponent.prototype, "type", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCModalChangeAccountComponent.prototype, "userEscrow", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCModalChangeAccountComponent.prototype, "forceLogout", void 0);
UiCModalChangeAccountComponent = __decorate([
    Component({
        selector: 'ui-c-modal-change-account',
        template: "<ion-content class=\"modal-change-account p-0\">\n  <ng-container>\n    <ion-row class=\"title\" [style.background-image]=\"'url(' + backgroundImage + ')'\">\n      <ion-col size=\"12\">\n        <p class=\"p-2\" *ngIf=\"!userEscrow\">{{ 'CASH_IN.DASHBOARD_MENU.CHANGE_ACCOUNT_MODAL' | wlpTranslate }}</p>\n        <p class=\"p-2\" *ngIf=\"userEscrow\">{{ 'CASH_IN.DASHBOARD_MENU.SELECT_AN_ACCOUNT_TO_MOVE' | wlpTranslate }}</p>\n      </ion-col>\n    </ion-row>\n    <ion-list>\n      <div\n        [ngClass]=\"accountInUse === el?.numberAccountBank ? 'account-selected p-0' : 'p-0'\"\n        *ngFor=\"let el of data; let i = index\"\n      >\n        <ion-item lines=\"none\" *ngIf=\"el?.accountType !== 'Usu\u00E1rio Escrow'\" (click)=\"accountSelection(el?.uuidAccount)\">\n          <ion-row class=\"card-user-row\">\n            <ion-col size=\"2\" class=\"card-user-col\">\n              <p class=\"text-center font-weight-bold\" id=\"card-username-icon\">\n                {{ el?.nameInitials }}\n              </p>\n            </ion-col>\n            <ion-col size=\"9\" class=\"card-user-col\">\n              <p class=\"card-user-name font-weight-bold pb-3\" *ngIf=\"accountInUse === el?.numberAccountBank\">\n                {{ 'DASHBOARD.USER_CARD_MENU.CHANGE_ACCOUNT.CURRENT_ACCOUNT' | wlpTranslate }}\n              </p>\n              <p class=\"card-user-name\">{{ 'CASH_IN.DASHBOARD_MENU.NAME' | wlpTranslate }}: {{ el?.accountName | titlecase }}</p>\n              <p class=\"card-user-name\">\n                {{ 'CASH_IN.DASHBOARD_MENU.BANK' | wlpTranslate }}: {{ el?.codeBank }} - {{ el?.nameBank | titlecase }}\n              </p>\n              <p class=\"card-user-name\">\n                <!-- {{ 'CASH_IN.DASHBOARD_MENU.DOCUMENT' | wlpTranslate }} -->\n                {{ verifyTypeDocument(el?.document) | wlpTranslate }}: {{ el?.document }}\n              </p>\n              <ng-container *ngIf=\"type == 'WEB'\">\n                <p class=\"card-user-email font-size-14\">\n                  {{ 'CASH_IN.DASHBOARD_MENU.AGENCY' | wlpTranslate }}: {{ el?.agencyBank }} |\n                  {{ 'CASH_IN.DASHBOARD_MENU.ACCOUNT' | wlpTranslate }}:\n                  {{ setDigitAccountBank(el?.numberAccountBank) }}\n                </p>\n              </ng-container>\n              <ng-container *ngIf=\"type == 'APP'\">\n                <p class=\"card-user-email font-size-14\">\n                  {{ 'CASH_IN.DASHBOARD_MENU.AGENCY' | wlpTranslate }}: {{ el?.agencyBank }}\n                </p>\n                <p class=\"card-user-email font-size-14\">\n                  {{ 'CASH_IN.DASHBOARD_MENU.ACCOUNT' | wlpTranslate }}:\n                  {{ setDigitAccountBank(el?.numberAccountBank) }}\n                </p>\n              </ng-container>\n            </ion-col>\n            <ion-col size=\"1\" class=\"card-user-col\">\n              <ion-icon class=\"icon\" name=\"chevron-forward-outline\"></ion-icon>\n            </ion-col>\n          </ion-row>\n        </ion-item>\n      </div>\n    </ion-list>\n    <ion-row class=\"btn-close\" *ngIf=\"!userEscrow\">\n      <ion-col size=\"12\">\n        <ion-button shape=\"round\" (click)=\"dismiss()\">\n          {{ 'CASH_IN.DASHBOARD_MENU.BUTTON_CLOSE' | wlpTranslate }}\n        </ion-button>\n      </ion-col>\n    </ion-row>\n    <ion-row class=\"btn-close\" *ngIf=\"userEscrow\">\n      <ion-col size=\"12\">\n        <ion-button shape=\"round\" (click)=\"dismiss('cancel')\">\n          {{ 'CASH_IN.DASHBOARD_MENU.BUTTON_CANCEL' | wlpTranslate }}\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ng-container>\n</ion-content>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [ModalController])
], UiCModalChangeAccountComponent);

let UiCModalChangeAccountModule = class UiCModalChangeAccountModule {
};
UiCModalChangeAccountModule = __decorate([
    NgModule({
        declarations: [UiCModalChangeAccountComponent],
        imports: [IonicModule, CommonModule, UiCButtonModule, AngularSvgIconModule.forRoot(), UiBsTranslateModule],
        exports: [UiCModalChangeAccountComponent],
    })
], UiCModalChangeAccountModule);

export { UiCModalChangeAccountComponent, UiCModalChangeAccountModule };
//# sourceMappingURL=wlp-ui-c-modal-change-account.js.map
